// extracted by mini-css-extract-plugin
export default {"bottomCtas":"ResetPassword_bottomCtas__7XfpH"};